import { ESCALATION_RULE_ADD_DATA, DROPDOWN_CACHE, RULE_LIST,  CATEGORY_DROPDOWN,
  STATUS_DROPDOWN,
  NOTIFICATION_VARIABLES,
  ESCALATION_GET_DATA,
  ESCALATION_RULE_UPDATE,
  ESCALATION_EXECUTIONS_GET,  } from "./Constants";
const initialAddRuleState = {
  loading: false,
  rule: {},
  addSuccess: false,
  addError: null,
};

  const initialDropdownState = {
    loading: false,
    error: null,
    cache: {},  // key: endpoint => value: dropdown data
  };

  const initialRuleListState = {
    loading: false,
    ruleList: [],
    error: null,
   
  };


const initialStateDropdown = {
  categoryList: [],
  statusList: [],
  notificationVariables: [],
  loadingCategory: false,
  loadingStatus: false,
  loadingNotificationVars: false,
  error: null,
};

// For edit escalation rule
const initialStateEscalation = {
  ruleDetails: null, 
  loading: false,  
  error: null,
  updating: false,
  updateError: null,
  updateSuccess: false,     
};

const initialStateEscalationExecution = {
  escalationExecutionData: [], 
  rowCount: 0,
  loading: false,  
  error: null,    
};

export const escalationReducer = (state = initialAddRuleState, action) => {
  switch (action.type) {
    case ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        rule: {},
      };

    case ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        rule: action.rule,
        addSuccess: true,
      };

    case ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        rule: {},
        addSuccess: false,
        addError: action.error,
      };
    
    case ESCALATION_RULE_ADD_DATA.ESCALATION_RULE_ADD_DATA_RESET:
      return {
        ...state,
        loading: false,
        rule: {},
        addSuccess: false,
        addError: null,
      };

    default:
      return state;
  }
};




export const DropdownReducer = (state = initialDropdownState, action) => {
  switch (action.type) {
    case DROPDOWN_CACHE.DROPDOWN_CACHE_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DROPDOWN_CACHE.DROPDOWN_CACHE_SUCCESS:
      return {
        ...state,
        loading: false,
        cache: {
          ...state.cache,
          [action.endpoint]: action.data
        },
      };

    case DROPDOWN_CACHE.DROPDOWN_CACHE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};



export const RuleListReducer = (state = initialRuleListState, action) => {
  switch (action.type) {
    case RULE_LIST.RULE_LIST_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case RULE_LIST.RULE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        ruleList: action.data,
      };
    
    case RULE_LIST.RULE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case RULE_LIST.RULE_LIST_DELETE:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case RULE_LIST.RULE_LIST_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    
    case RULE_LIST.RULE_LIST_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};


export default function ticketingDropdownReducer(state = initialStateDropdown, action) {
  switch (action.type) {

    // CATEGORY
    case CATEGORY_DROPDOWN.LOAD:
      return { ...state, loadingCategory: true };

    case CATEGORY_DROPDOWN.SUCCESS:
      return { ...state, loadingCategory: false, categoryList: action.data };

    case CATEGORY_DROPDOWN.FAIL:
      return { ...state, loadingCategory: false, error: action.error };


    // STATUS
    case STATUS_DROPDOWN.LOAD:
      return { ...state, loadingStatus: true };

    case STATUS_DROPDOWN.SUCCESS:
      return { ...state, loadingStatus: false, statusList: action.data };

    case STATUS_DROPDOWN.FAIL:
      return { ...state, loadingStatus: false, error: action.error };


    // NOTIFICATION VARIABLES
    case NOTIFICATION_VARIABLES.LOAD:
      return { ...state, loadingNotificationVars: true };

    case NOTIFICATION_VARIABLES.SUCCESS:
      return { ...state, loadingNotificationVars: false, notificationVariables: action.data };

    case NOTIFICATION_VARIABLES.FAIL:
      return { ...state, loadingNotificationVars: false, error: action.error };


    default:
      return state;
  }
}


// For edit escalation rule
export const escalationGetDataReducer = (state = initialStateEscalation, action) => {
  switch (action.type) {
    case ESCALATION_GET_DATA.ESCALATION_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        ruleDetails: null, // clear old data
      };

    case ESCALATION_GET_DATA.ESCALATION_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        ruleDetails: action.data,
      };

    case ESCALATION_GET_DATA.ESCALATION_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

     // Update rule
    case ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_LOAD:
      return {
        ...state,
        updating: true,
        updateError: null,
      };

    case ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        ruleDetails: action.data,
      };

    case ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_FAIL:
      return {
        ...state,
        updating: false,
        updateError: action.error,
        updateSuccess: false,
      };
    
    case ESCALATION_RULE_UPDATE.ESCALATION_RULE_UPDATE_RESET:
      return {
        ...state,
        updating: false,
        updateError: null,
        updateSuccess: false,
      };

    default:
      return state;
  }
};

// For escalation execution list

export const escalationExecutionListReducer = (state = initialStateEscalationExecution, action) => {
  switch (action.type) {
    case ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_LOAD:
      return {
        ...state,
        loading: true,
        error: null,
        escalationExecutionData: [], 
      };

    case ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        escalationExecutionData: action.data,
      };

    case ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_ROW_COUNT:
      return {
        ...state,
        loading: true,
        error: null,
        rowCount: 0, 
      };

    case ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_ROW_COUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        rowCount: action.data.rowCount,
      };

    case ESCALATION_EXECUTIONS_GET.ESCALATION_EXECUTIONS_GET_ROW_COUNT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };


    default:
      return state;
  }
};




